import { type IBugReport } from '@/app/types/settingsTypes'
import { Loader } from '@/shared'

import { SectionTitle } from '../SectionTitle/SectionTitle'

import style from './BugReport.module.scss'
import { ReportsList } from './ReportsList/ReportsList'

interface IProps {
    bugReportList: IBugReport[] | null
    onRemoveBugReport: (id: string) => void
    onSetSearchableAgentId: (searchableAgentId: string | null) => void
}

export const BugReport = (props: IProps) => {
    const { bugReportList, onRemoveBugReport, onSetSearchableAgentId } = props

    return (
        <div className={style.container}>
            <SectionTitle
                header='Сообщения об ошибках'
                description='Раздел для мониторинга сообщений и жалоб пользователей ЛК'
            />
            <div className={style.sectionContent}>
                {!bugReportList && <Loader />}
                {bugReportList && (
                    <ReportsList
                        bugReportList={bugReportList}
                        onRemoveBugReport={onRemoveBugReport}
                        onSetSearchableAgentId={onSetSearchableAgentId}
                    />
                )}
            </div>
        </div>
    )
}
